import { render, staticRenderFns } from "./core-common-access-description-column.vue?vue&type=template&id=46a528c4"
import script from "./core-common-access-description-column.vue?vue&type=script&lang=js"
export * from "./core-common-access-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports